<template>
  <div class="environmental_college">
    <div
      class="environmental_banner"
      :style="{ backgroundImage: `url(${banner && banner.image})` }"
    >
      <div class="warp">
        <div class="environmental_content">
          <h2>环学院</h2>
          <div class="environmental_body">
            <img src="../../assets/images/icons_66.png" alt="" />
            <div class="environmental_line"></div>
            <div class="environmental_desc">
              <p>ENVIRONMENTAL</p>
              <p>COLLEGE</p>
            </div>
          </div>
        </div>
        <div class="environmental_sign" v-if="!isLogin">
          <p class="environmental_option">
            <span :class="{ active: loginType == 1 }" @click="loginSwitch(1)"
            >账号登录</span
            >
            <span :class="{ active: loginType == 2 }" @click="loginSwitch(2)"
            >短信登录</span
            >
          </p>

          <!-- 账号登录 -->
          <el-form
            ref="form"
            v-if="loginType == 1"
            class="accountLoginForm"
            :rules="rules"
            :model="form"
          >
            <el-form-item class="phone" prop="mobile" style="width: 100%">
              <img class="icon" src="../../assets/images/shouji.png" alt="" />
              <el-input
                class="myClass"
                placeholder="请输入手机号码"
                v-model="form.mobile"
              ></el-input>
            </el-form-item>
            <el-form-item class="phone" prop="password">
              <img class="icons" src="../../assets/images/mima.png" alt="" />
              <el-input
                type="password"
                class="myClass"
                placeholder="请输入密码"
                v-model="form.password"
              ></el-input>
            </el-form-item>
            <div class="retrieve fdc">
              <p class="underline" @click.prevent="onRetrieve()">找回密码</p>
              <p>
                <span>没有账号,</span>
                <span class="underline" @click.prevent="onRegister()"
                >去注册</span
                >
              </p>
            </div>
            <el-form-item style="width: 100%">
              <el-button class="reset_login" @click="loginSubmit('form')"
              >确定登录</el-button
              >
            </el-form-item>
          </el-form>

          <!-- 短信登录 -->
          <el-form v-else class="phoneLoginForm" :rules="rulesForm" ref="loginForm" :model="loginForm">
            <el-form-item class="phone" prop="mobile" style="width: 100%">
              <img class="icon" src="../../assets/images/shouji.png" alt="" />
              <el-input
                class="myClass"
                placeholder="请输入手机号码"
                v-model="loginForm.mobile"
              ></el-input>
            </el-form-item>

            <el-form-item
              class="code"
              prop="imgCode"
              style="width: 100%"
            >
              <img
                class="icon"
                src="../../assets/images/security.png"
                alt=""
              />
              <el-input
                class="myClass"
                placeholder="图形验证码"
                v-model="loginForm.imgCode"
                maxlength="5"
              ></el-input>
              <img
                class="graphic_code"
                :src="imgUrl"
                alt=""
                @click.prevent="getCaptcha()"
              />
            </el-form-item>
            <el-form-item class="code" prop="smsCode">
              <img class="icons" src="../../assets/images/dunpai.png" alt="" />
              <el-input
                class="myClass"
                placeholder="请输入短信验证码"
                v-model="loginForm.smsCode"
                maxlength="6"
              ></el-input>
              <button class="shortBtn" @click.prevent="onCode()">
                {{ getCodeText }}
              </button>
            </el-form-item>
            <div class="retrieve fdc">
              <p class="underline" @click.prevent="onRetrieve()">找回密码</p>
              <p>
                <span>没有账号,</span>
                <span class="underline" @click.prevent="onRegister()"
                >去注册</span
                >
              </p>
            </div>
            <el-form-item style="width: 100%">
              <el-button class="reset_login" @click="goLogin('loginForm')">确定登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <div class="technology_item warp" id="navA">
      <div class="technology_search_criteria">
        <span class="technology_search_tips">分类:</span>
        <ul>
          <li
            :class="current == index ? 'active' : ''"
            v-for="(item, index) in dictList"
            :key="index"
            @click="navChange(index,'#page' + index)"
          >
            <span> {{ item.name }}</span>
          </li>
        </ul>
      </div>
      <div class="search_input">
        <el-select class="select_list" v-model="value" placeholder="" @change="onChange">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <input type="text" v-model="keyword"  @keyup.enter="onSeach()" placeholder="请输入你要查询的关键字" />
        <button  @click.prevent="onSeach()"><img src="../../assets/images/search.png" alt="" /></button>
      </div>
      <!-- <div class="search_keywords">
        <span>关键字:</span>
        <span v-for="(item, index) in 4" :key="index">大气治理{{ item }}</span>
      </div> -->
    </div>

    <!-- 热门课程 -->
    <div class="class_hot warp">
      <h3> {{collegeText}}</h3>
      <div class="calss_hot_content">
        <div :class="[collegeText =='热门课件'?'class_hot_left mb-20':'class_hot_left']" @click="goDetail(hotLesson)">
          <div class="img">
            <img :src="hotLesson.cover" alt="" />
            <img  :class="[collegeText =='热门课件'?'dn':'moder']" src="../../assets/images/play.png" alt="">
          </div>
          <!-- <div class="" ></div> -->
          <p class="class_hot_title">{{ hotLesson.title }}</p>
          <div class="class_hot_desc">
            <p>
              <span> 主讲人：{{ hotLesson.fistprofessorname || "无" }} </span>
              <span>观看人数：{{ hotLesson.viewerscount }}</span>
            </p>
            <s v-if="hotLesson.price ==0">免费</s>
            <s v-else>￥{{ hotLesson.price}}/{{ hotLesson.integral }}积分</s>
          </div>
        </div>
        <div class="class_hot_right">
          <ul>
            <li
              v-for="(item, index) in recommendLesson.slice(0, 4)"
              :key="index"
              @click="goDetail(item)"
            >
              <div v-if="collegeText=='热门课程'"  class="model"></div>
              <div class="img">
                <img :src="item.cover" alt="" />
              </div>
              <p class="class_hot_title">{{ item.title }}</p>
              <div class="class_hot_desc">
                <p>
                  <span> 主讲人：{{ item.fistprofessorname || "无" }} </span>
                  <span>观看人数：{{ item.viewerscount }}</span>
                </p>
                 <s v-if="item.price ==0">免费</s>
                 <s v-else>￥{{ item.price}}</s>
              </div>
            </li>
          </ul>
           <!--没有数据时-->
           <div style="margin-top:25%;">
             <notList :notCode="notCode"></notList>
            </div>
        </div>
      </div>
    </div>

    <!-- 导师介绍 -->
    <div class="participating_experts warp">
      <h3 class="tips">导师 介绍</h3>
      <div class="exports_list">
        <div class="button-prev" @click="swiperChange('prev')">
          <svg
            t="1603440419638"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2695"
            width="32"
            height="32"
          >
            <path
              d="M671.807 927.804l-415.632-415.804 415.632-415.803 63.445 63.616-352.017 352.209 352.017 352.102z"
              p-id="2696"
              fill="#8a8a8a"
            ></path>
          </svg>
        </div>
        <div v-swiper:mySwiper="swiperOption" v-if="expertList.length > 0">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide box"
              v-for="(item, index) in expertList"
              :key="index"
            >
              <expert-card :info="item"></expert-card>
            </div>
          </div>
        </div>
        <div class="button-next" @click="swiperChange('next')">
          <svg
            t="1603440337801"
            class=""
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2017"
            width="32"
            height="32"
          >
            <path
              d="M325.048 93.511l-60.030 59.435 357.181 359.631-360.184 356.603 59.522 59.93 420.207-416.043z"
              p-id="2018"
              fill="#8a8a8a"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    <!--     分类-->
    <div class="example warp" v-for="(item, i) in dictList" :key="i" :id="'#page' + i">
      <div class="example_head" v-if="commonLesson[i] !=undefined && commonLesson[i].length>0">
        <div>
          <h3>{{ item.name }}</h3>
          <span @click="onChange(item.id,i)">换一批</span>
        </div>
        <div>
          <span @click="onChange_f(item.id,i)">换一批</span>
        </div>
      </div>
      <div class="example_list" v-if="commonLesson[i] !=undefined && commonLesson[i].length>0">
        <div class="example_list_left">
          <ul>
            <li
              v-for="(itemc, index) in commonLesson[i]"
              :key="index"
              @click="goDetail(itemc)"
            >
             <div v-if="index <6">
                <div class="model"></div>
              <div class="img">
                <img :src="itemc.cover" alt="" />
              </div>
              <p class="example_title">{{ itemc.title }}</p>
              <div class="example_desc">
                <p>
                  <span> 主讲人：{{ itemc.fistprofessorname || "无" }} </span>
                  <span>观看人数：{{ itemc.viewerscount }}</span>
                </p>
                 <s v-if="itemc.price ==0">免费</s>
                 <s v-else>￥{{ itemc.price}}/30积分</s>
              </div>
             </div>

            </li>
          </ul>
        </div>
        <div class="example_list_right">
          <ul>
            <li
              v-for="(inner, innerIndex) in commonLessonData[i]"
              :key="innerIndex"

              @click="goDetail(inner)"
            >
             <div  v-if="innerIndex <4" class="fsb">
                <div class="curr_img">
                    <img :src="inner.cover" alt="" />
                </div>
                <div class="example_info">
                  <p>{{ inner.title }}</p>
                  <span>观看人数：{{ inner.viewerscount }}</span>
               </div>
             </div>
            </li>
          </ul>
        </div>
      </div>
    </div>


  </div>
</template>


<script>
import {
getLessonList,
getExpertList,
getBanner,
getRandomLessonList
} from "../../api/information";
import expertCard from "../../components/expertCard";
import notList from "../../common/notList"
import { phoneNumValidate} from "@/utils";
import { getToken } from "@/utils/auth";
import { formatTime,getUUID,getRandomArray,routerGoNewpage} from "@/utils/index.js";
import {smslogin,SmsCaptcha } from "@/api/user";
import {myfunds,vod,getDict} from "@/api/coment"
import NotList from '../../common/notList.vue';
  export default {
    components: {
      expertCard,notList
    },
    data() {
      var validatePhone = (rules, value, callback) => {
        // 验证手机号的正则表达式
        // const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
        const regMobile = /^1[34578]\d{9}$/;
        if (regMobile.test(value)) {
          return callback();
        }
        callback(new Error("请输入合法的手机号"));
      };
      return {
        getCodeText: "获取验证码",
        getCodeisWaiting: false,
        form: {
          mobile: "",
          password: "",
        },
        loginForm: {
          mobile: "",
          imgCode:"",
          smsCode: "", //短信验证码
        },
        rules: {
          mobile: [
            { required: true, message: "请输入手机号码", trigger: "blur" },
            { validator: validatePhone, trigger: "blur" },
          ],
          password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        },
        rulesForm: {
           mobile: [
            { required: true, message: "请输入手机号码", trigger: "blur" },
            { validator: validatePhone, trigger: "blur" },
           ],
           imgCode: [{ required: true, message: "请输入图形验证码", trigger: "blur" }],
           smsCode: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
        },
        activeName: "first",
        type: "login",
        swiperOption: {
          slidesPerView: 4, // 显示的数量
          spaceBetween: 30, // 每张的间距
          slidesPerGroup: 1,
        },
        value: 0,
        options: [
          { value: 0, label: "视频" },
          { value: 1, label: "课件" },
        ],
        current: 0,
        hotLesson: {},
        recommendLesson: [],
        Lesson:[],
        commonLesson: [],
        commonLessonData: [],
        expertList: [],
        expertQuery:{
          curPage: 1,
          limit: 10
        },
        dataLists: [],
        loginType: 1,
        isLogin: false,
        imgUrl: "",
        navType: "6",
        banner: "",
        uuid:'',
        keyword:'', //搜索关键字
        clist:[],
        notCode:false,
        collegeText:'热门课程',
        totals:0
      };
    },
    created() {
      this.$nextTick(() => {
          this.isLogin = !!getToken();
          if(undefined== this.dataLists || false==this.dataLists){
            this.getCailter();
          }
          this.init();
      });
      this.getMate();

     if(this.$route.query.type){
        var type  = this.$route.query.type;
        this.collegeText ="热门课件"
        getLessonList({sourcetype:type}).then((res)=>{
          if(res.code == 0){
             res.page.list.forEach((item,index)=>{
               if(index == 0){
                 this.hotLesson = item;
               }else{
                 this.recommendLesson.push(item)
               }
             });
          }
        })
     }

    },
    computed: {
      dictList() {
        return (
          this.$store.state.industry.list.length > 0 &&
          this.$store.state.industry.list[0].children
        );
      },
    },
    methods: {
      industryList_detection(id){
        var arr = [15,16,17,18]
        if (arr.indexOf(id) != -1){
          return false
        }else{
          return true
        }
      },
      init(){
        this.getLessonList_v();
        this.getLessonList_f();
        if(!this.$route.query.type){
          this.getHotLessonList();
          this.getRecommendlist();
        }
        this.getExpertList();
        this.getBanner();
        this.getCaptcha();
      },
      setTimer() {
        let holdTime = 60;
        this.getCodeText = "重新获取(60)";
        this.Timer = setInterval(() => {
          if (holdTime <= 0) {
            this.getCodeisWaiting = false;
            this.getCodeText = "获取验证码";
            holdTime = 60;
            clearInterval(this.Timer);
            return;
          }
          this.getCodeText = "重新获取(" + holdTime + ")";
          holdTime--;
        }, 1000);
      },
      //获取图形验证码
      getCaptcha() {
        this.uid = getUUID();
        this.imgUrl = `/api/zwb/app/captcha.jpg?uuid=${this.uid}`;
      },
      //发送验证码
      onCode() {
        if (!this.loginForm.mobile) {
          this.$message({
            message: "请输入手机号",
            type: "warning",
            duration: 1000,
          });
          return;
        }
        if (!this.loginForm.imgCode) {
          this.$message({
            message: "请输入图形验证码",
            type: "warning",
            duration: 1000,
          });
          return;
        }
        if (this.getCodeisWaiting) {
          return false;
        }
        let params = {
          mobile: this.loginForm.mobile,
          uuid: this.uid,
          imgCode: this.loginForm.imgCode,
        };
        this.setTimer();
        this.getCodeisWaiting = true;
        SmsCaptcha(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "验证码发送成功",
              type: "success",
              duration: 1000,
            });
          }
        }).catch((err) => {});
      },
      getBanner() {
        getBanner({
          type: this.navType,
        }).then((res) => {
          this.banner = res.page.list[0];
        });
      },
      //密码登录
      loginSubmit(formName) {
         this.$refs[formName].validate((valid) => {
         if (valid) {
          this.$store
            .dispatch("user/login", {
              mobile: this.form.mobile,
              password: this.form.password,
            })
            .then((res) => {
              this.$message({
                message: "登录成功",
                type: "success",
                duration: 1000,
                onClose: () => {
                  window.location.reload();
                  this.$router.push({ path:"/environmental_college"});
                  this.isLogin = true;
                },
              });
            })
            .catch(() => {});
         } else {
          return false;
         }
       });
      },
        //短信登录
      goLogin(formName){
      this.$refs[formName].validate((valid)=>{
        if(valid){
          this.$store.dispatch("user/smslogin",{
            mobile:this.loginForm.mobile,
            smsvaildCode:this.loginForm.smsCode,
            uuid:this.uid,
            vaildCode:this.loginForm.imgCode
          }).then((res)=>{
             if(res.code == 0){
               this.$message({
                message: "登录成功",
                type: "success",
                duration: 1000,
                onClose: () => {
                  window.location.reload();
                  this.$router.push({path:  "/environmental_college"});
                  this.isLogin = true;
                },
              });
             }
          }).catch((err)=>{})
        }
      })
      },

      loginSwitch(type) {
        this.loginType = type;
      },
      toExpertDetail(item) {
        routerGoNewpage('/expert_detail',{id:item.userId})
      },
      //获取专家列表
      getExpertList() {
        getExpertList({
          ...this.expertQuery,
          weight:0
        }).then((res) => {
          this.totals = res.data.totalCount;
          this.expertList = this.expertList.concat(res.data.list);
        });
      },
      //获取热门课程(1个)
      getHotLessonList() {
        getLessonList({
          curPage: 1,
          limit: 1,
          sourcetype:0,
          top: 1,
        }).then((res) => {
          this.hotLesson = res.page.list.slice(0, 1)[0];
          // this.getMate(this.hotLesson)
        });
      },
      //获取推荐课程
      getRecommendlist() {
        getLessonList({
          curPage: 1,
          limit: 5,
          sourcetype:0,
          recommend: 1,
        }).then((res) => {
          if(res.code == 0){
            let arr = [];
            res.page.list.map((item)=>{
              if(this.hotLesson.id == item.id) return;
              arr.push(item)
            });
            this.recommendLesson = arr;
          }
        });
      },
      //切换随机视频
      onChange(category,i) {
        if(category == 0){
          this.onSeach();
          this.collegeText = '热门课程';
        }else{
           this.collegeText ='热门课件';
        }
        let params={category:category,sourcetype:0,count:6};
        getRandomLessonList(params).then((res)=>{
          if(res.code ==0){
            this.commonLesson[i]=res.list;
            this.commonLesson.push({});
            this.recommendLesson = res.list;
		      	this.recommendLesson.length == 0 ? this.notCode = true : this.notCode = false;
          }
        });
      },
       //获取分类
       getCailter(){
        getDict().then(res=>{
          if(res.code ==0){
            this.dataLists = res.data[0].children;
            this.init();
          }
        }).catch(err=>{});
      },
      //切换随机课件
      onChange_f(category,i){
        let params={category:category,sourcetype:1,count:4};
        getRandomLessonList(params).then((res)=>{
          if(res.code == 0){
            this.commonLessonData[i]= res.list;
            this.commonLessonData.push({});
          }
        });
      },
      //根据lessonlist
      getLessonList_v() {
            if(this.dataLists == null || this.dataLists.length == 0){
               return;
            }
            if(this.clist.length==0 &&  this.dataLists.length>0 ){
                this.dataLists.forEach(element => {
                  this.clist.push(element.id);
                  this.commonLesson.push([]);
                  this.commonLessonData.push([]);
              });
            }
            getLessonList({
                curPage: 1,
                limit: 60,
                sourcetype: 0
            }).then((res)=>{
              if(res.code == 0){
                  res.page.list.forEach(item=>{
                    let index=Number(this.clist.indexOf(item.category)) ;

                    if( undefined!=this.commonLesson[index] ){
                      this.commonLesson[index].push(item);
                    }
                  });
              }
            })

      },
      getLessonList_f() {
          if(this.dataLists == null || this.dataLists.length ==0){
              return;
            }
          if(this.clist.length==0 &&  this.dataLists.length>0){
                this.dataLists.forEach(element => {
                  this.clist.push(element.id);
                  this.commonLesson.push([]);
                  this.commonLessonData.push([]);
              });
          }
          getLessonList({curPage: 1,limit: 60,sourcetype: 1}).then((res)=>{
            if(res.code == 0){
                res.page.list.forEach(item=>{
                  let index=Number(this.clist.indexOf(item.category)) ;
                  if( undefined!= this.commonLessonData[index]){
                      this.commonLessonData[index].push(item);
                  }
                })
            }
          })
          return

      },
      //找回密码
      onRetrieve() {
        this.$router.push("/retrieve");
      },
      //注册
      onRegister() {
        this.$router.push("/register");
      },
      goDetail(item) {
        routerGoNewpage('/environmental_college_detail',{id:item.id})
      },
      //切换轮播图
      swiperChange(type) {
        switch (type) {
          case "prev":
            this.mySwiper.slidePrev();
            break;

          default:
            this.mySwiper.slideNext();
            if(this.mySwiper.slideNext() == false){
               this.expertQuery.curPage ++ ;
               if(this.totals == this.expertList.length) return;
               this.getExpertList();
            }
            break;
        }
      },
      navChange(index,selector) {
        this.current = index;


        var anchor = document.getElementById(selector);
        //document.documentElement.scrollTop = anchor.offsetTop;

        var total = anchor.offsetTop;

        // 平滑滚动，时长500ms，每10ms一跳，共50跳
        // 获取当前滚动条与窗体顶部的距离
        let distance =
          document.documentElement.scrollTop || document.body.scrollTop;
        // 计算每一小段的距离
        let step = total / 50;
        (function smoothDown() {
          if (distance < total) {
            distance += step; // 移动一小段
            document.body.scrollTop = distance;
            document.documentElement.scrollTop = distance; // 设定每一次跳动的时间间隔为10ms
            setTimeout(smoothDown, 10);
          } else {
            // 限制滚动停止时的距离
            document.body.scrollTop = total;
            document.documentElement.scrollTop = total;
          }
        })();
      },


      //搜索课程课件
      onSeach(){
        getLessonList({
          curPage:1,
          limit:10,
		      sourcetype:this.value,
          keyword:this.keyword
        }).then((res)=>{
          if(res.code ==0){
            this.recommendLesson = res.page.list;
            this.recommendLesson.length == 0 ? this.notCode = true : this.notCode = false;
          }
        }).catch((err)=>{})
      },
      getMate(){
        var metas = document.getElementsByTagName("meta");
        // metas[0].name ="keyword"
        // metas[0].content= data[0].seokeywords
        // metas[1].name ="description"
        // metas[1].content=data[0].seodescription
        document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
        // document.getElementsByTagName("title")[0].innerText= data[0].title +'_智污邦环保服务平台';
     },
    },
  };
</script>

<style scoped lang='less'>
.fsb{
  display: flex;
  justify-content: space-between;
}
.curr_img{
  width: 146px;
  height: 117px;
  display:flex;
  justify-content:center;
  align-items: center;
}
  .select_list {
    width: 20%;
    /deep/ .el-input__inner {
      height: 53px;
      border-radius: 0;
      border-right: 0;
      border-color: #65b62b;
      text-align: center;
    }
    /deep/ .el-input.is-focus .el-input__inner {
      border-color: #65b62b !important;
    }
    /deep/ .el-input__inner:focus {
      border-color: #65b62b !important;
    }
  }

  .environmental_college {
    .environmental_banner {
      width: 100%;
      height: 399px;
      background: url("../../assets/images/environmental_bg.jpg") no-repeat
        center/cover;
      // @media (min-width: 1600px) {
      //   padding: 0 22%;
      // }
      .warp {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;
        .environmental_content {
          width: 291px;
          h2 {
            font-size: 95px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
          }
          .environmental_body {
            display: flex;
            align-items: center;
            justify-content: space-between;
            img {
              width: 75px;
              height: 55px;
              object-fit: cover;
            }
            .environmental_line {
              width: 1px;
              height: 56px;
              background: #ffffff;
            }
            .environmental_desc {
              p {
                &:nth-of-type(1) {
                  font-size: 22px;
                  font-family: Arial;
                  font-weight: bold;
                  color: #ffffff;
                }
                &:nth-of-type(2) {
                  font-size: 41px;
                  font-family: Arial;
                  font-weight: bold;
                  color: #ffffff;
                }
              }
            }
          }
        }

        .environmental_sign {
          width: 390px;
          height: 100%;
          padding: 29px;
          background: rgba(0, 0, 0, 0.5);
          .environmental_option {
            margin-bottom: 26px;
            span {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              padding-bottom: 5px;
              cursor: pointer;
              &.active {
                border-bottom: 1px solid #fff;
              }
              &:nth-of-type(1) {
                margin-right: 23px;
              }
            }
          }
          .el-form {
            /deep/.phone .el-button {
              position: absolute;
              height: 40px;
              top: 0;
              right: 0;
              color: #ffffff;
              width: 95px;
              background: #fb7103;
              border: none;
              font-size: 12px;
            }
            /deep/ .el-input__inner {
              padding-left: 40px;
            }
            .phone {
              position: relative;
            }
            .code {
              position: relative;
            }
            .shortBtn{
              position: absolute;
              top: 0;
              right: 0;
              width: 125px;
              height: 40px;
              background: #e5e5e5;
              border: 1px solid #999999;
              opacity: 0.7;
            }
            .icon {
              width: 20px;
              height: 20px;
              position: absolute;
              top: 10px;
              left: 10px;
              z-index: 100;
            }
            .icons {
              width: 20px;
              height: 20px;
              position: absolute;
              top: 10px;
              left: 10px;
              z-index: 100;
            }
            .graphic_code {
              position: absolute;
              right: 0;
              top: 0;
              width: 125px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              font-size: 21px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              background: #cdcdcd;
              color: #323232;
            }
            .retrieve {
              margin-bottom: 22px;
              p {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #ffffff;
              }
              .underline {
                padding-bottom: 5px;
                text-decoration: underline;
                cursor: pointer;
              }
            }
            .reset_login {
              width: 100%;
              height: 40px;
              background: rgba(59, 174, 48, 1);
              border: none;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
            }
          }
        }
      }
    }
    .class_hot {
      h3 {
        margin: 0 0 20px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
      .calss_hot_content {
        display: flex;
        // justify-content: space-between;
        .class_hot_left {
          width: 65%;
          position: relative;
          cursor: pointer;
          // margin-right: 28px;
          .img {
            width: 100%;
            height: 403px;
            overflow: hidden;
            position: relative;
            img {
              width: 100%;
              height: 100%;
              transition: all 0.5s;
              &:hover {
                transform: scale(1.2);
              }
            }
          }
          .moder{
            position: absolute;
            width: 50px !important;
            height: 50px !important;
            // background: url("../../assets/images/play.png") no-repeat center/100%;
            top: 50%;
            right: 50%;
            margin-top: -25px;
            margin-right: -25px;
            z-index: 100;
          }
          .class_hot_title {
            margin: 5px 0 10px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }
          .class_hot_desc {
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            p {
              display: flex;
              flex-direction: column;
              span {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
                &:nth-of-type(1) {
                  margin-bottom: 5px;
                }
              }
            }
            s {
              font-size: 14px;
              font-family: STHeitiSC;
              font-weight: 600;
              color: #ff3000;
              text-decoration: none;
            }
          }
        }
        .class_hot_right {
          width: 55%;
          margin-left: 2%;
          ul {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            li {
              position: relative;
              cursor: pointer;
              width: 49%;
              margin-bottom: 2%;
              margin-right: 2%;
              &:nth-of-type(2n) {
                margin-right: 0;
              }
              &:nth-last-of-type(-n + 2) {
                margin-bottom: 0;
              }
              .model {
                position: absolute;
                width: 50px;
                height: 50px;
                background: url("../../assets/images/play.png") no-repeat
                  center/100%;
                top: 23%;
                right: 50%;
                /* margin-top: -25px; */
                margin-right: -25px;
                z-index: 999;
              }
              .img {
                width: 100%;
                height: 158px;
                overflow: hidden;
                img {
                  width: 100%;
                  height: 100%;
                  filter: brightness(0.5);
                  transition: all 0.5s;
                  &:hover {
                    transform: scale(1.2);
                  }
                }
              }
              .class_hot_title {
                margin: 5px 0 10px;
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .class_hot_desc {
                display: flex;
                align-items: flex-end;
                justify-content: space-between;
                p {
                  display: flex;
                  flex-direction: column;
                  span {
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #999999;
                    &:nth-of-type(1) {
                      margin-bottom: 5px;
                    }
                  }
                }
                s {
                  font-size: 14px;
                  font-family: STHeitiSC;
                  font-weight: 600;
                  color: #ff3000;
                  text-decoration: none;
                }
              }
            }
          }
        }
      }
    }
    .participating_experts {
      // margin-top: 59px;
      border-top: 1px solid #eeeeee;
      h3 {
        margin: 35px 0;
        text-align: center;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
      .exports_list {
        display: flex;
        align-items: center;
        .button-prev,
        .button-next {
          margin-top: 100px;
          cursor: pointer;
        }
      }
    }
    .example {
      margin-top: 30px;
      .example_head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        div {
          &:nth-of-type(1) {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex: 7;
            margin-right: 30px;
          }
          &:nth-of-type(2) {
            flex: 3;
            text-align: right;
          }
          h3 {
            position: relative;
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333333;
            &::before {
              display: inline-block;
              content: "";
              width: 5px;
              height: 23px;
              background: #ff7302;
              position: absolute;
              left: -15px;
              bottom: 4px;
            }
          }
          span {
            cursor: pointer;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #9a9a9a;
            &::before {
              display: inline-block;
              content: "";
              width: 17px;
              height: 17px;
              background: url("../../assets/images/break.png") no-repeat
                center/100%;
              vertical-align: bottom;
              margin-right: 3px;
            }
          }
        }
      }
      .example_list {
        display: flex;
        justify-content: space-between;
        .example_list_left {
          flex: 7;
          margin-right: 15px;
          ul {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            &::after {
              width: 30%;
              content: "";
            }
            li {
              position: relative;
              cursor: pointer;
              width: 32%;
              margin-bottom: 2%;
              &:nth-last-of-type(-n + 2) {
                margin-bottom: 0;
              }
              .img {
                width: 100%;
                height: 158px;
                overflow: hidden;
                img {
                  width: 100%;
                  height: 100%;
                  transition: all 0.5s;
                  &:hover {
                    transform: scale(1.2);
                  }
                }
              }
              img {
                width: 100%;
                height: 158px;
                filter: brightness(0.5);
              }
              .model {
                position: absolute;
                width: 50px;
                height: 50px;
                background: url("../../assets/images/play.png") no-repeat
                  center/100%;
                top: 25%;
                right: 50%;
                /* margin-top: -25px; */
                margin-right: -25px;
                z-index: 999;
              }
              .example_title {
                margin: 5px 0 10px;
                font-size: 17px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;

                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .example_desc {
                display: flex;
                align-items: flex-end;
                justify-content: space-between;
                p {
                  display: flex;
                  flex-direction: column;
                  span {
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #999999;
                    &:nth-of-type(1) {
                      margin-bottom: 5px;
                    }
                  }
                }
                s {
                  font-size: 14px;
                  font-family: STHeitiSC;
                  font-weight: 600;
                  color: #ff3000;
                  text-decoration: none;
                }
              }
            }
          }
        }
        .example_list_right {
          flex: 3;
          border-top: 3px solid rgba(153, 207, 42, 1);
          background: #f8f8f8;
          padding: 18px 15px;
          height: 533px;
          ul {
            li {
              display: flex;
              justify-content: space-between;
              margin-bottom: 10px;
              &:last-of-type {
                margin-bottom: 0;
              }
              img {
                width: 113px;
                height: 113px;
                object-fit: fill;
              }
              .example_info {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                margin-left: 12px;
                width: 100%;
                p {
                  max-width: 176px;
                  font-size: 18px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #000000;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                }
                span {
                  font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #999999;
                }
              }
            }
          }
        }
      }
    }
  }
  .swiper-container {
    width: 100%;
  }
  .swiper-wrapper {
    width: 100%;
    height: 400px;
    position: relative;
  }

  .technology_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 40px auto;
    .technology_search_criteria {
      // width: 60%;
      display: flex;
      align-items: center;
      border-bottom: 1px dashed #e1e1e1;
      border-top: 1px dashed #e1e1e1;
      &:nth-of-type(2) {
        border-top: none;
      }
      .technology_search_tips {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-right: 20px;
        width: 38px;
        display:inline-block;
      }
      ul {
        display: flex;
        padding: 5px 0;
        li {
          width: 70px;
          text-align: center;
          cursor: pointer;
          margin-right: 20px;
          padding: 5px 0;
          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }
        }
        .active {
          background: #3bae30;
          border-radius: 3px;
          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            padding: 5px 0;
          }
        }
      }
    }
    .search_input {
      // width: 38%;
      margin-left: 25px;
      display: flex;
      input {
        flex: 7;
        border: 1px solid #65b62b;
        border-right: none;
        border-left: none;
        padding: 16px;
      }
      button {
        padding: 0 34px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        background: #3bae30;
        img {
          width: 21px;
          height: 21px;
        }
      }
    }
    .search_keywords {
      margin-top: 5px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      span {
        margin-right: 10px;
        &:first-of-type {
          margin-right: 0;
        }
      }
    }
  }

  .el-select-dropdown__item.selected{
    color: #3bae30 !important;
  }
.dn{
  display: none;
}
.mb-20{
  margin-bottom: 20px;
}
</style>





// WEBPACK FOOTER //
// src/view/college/environmental_college.vue